import React from "react";
import ReactResizeDetector from "react-resize-detector";
import { Link, Redirect } from "react-router-dom";
import Context from "../../../Context";
import EssenceActionsDropdown from "../../Essence/EssenceActionsDropdown";
import EssenceStateLabel from "../../Essence/EssenceStateLabel";
import EssenceAreaChange from "../../Essence/EssenceAreaChange";
import Blocker from "../../Misc/Blocker";
import DefaultNotFound from "../../Misc/DefaultNotFound";
import WorkdocRequest from "./Viewers/WorkdocRequest";
import WorkdocOrder from "./Viewers/WorkdocOrder";
import WorkdocItemInfo from "./WorkdocItemInfo";
import WorkdocDelivery from "./Viewers/WorkdocDelivery";
import WorkdocUndertake from "./Viewers/WorkdocUndertake";
import WorkdocFda from "./Viewers/WorkdocFda";
import WorkdocRepair from "./Viewers/WorkdocRepair";
import WorkdocBunkerOrder from "./Viewers/WorkdocBunkerOrder";
import WorkdocActMaintenance from "./Viewers/WorkdocActMaintenance";
import CommentsButton from "../../Misc/Comments/CommentsButton";
import FilesModalButton from "../../Misc/FilesModal/FilesModalButton";
import WorkdocPrintButton from "../../Misc/WorkdocPrintButton";
import PriorityIcon from "../../Misc/PriorityIcon";
import WorkdocTimesheet from "./Viewers/WorkdocTimesheet";

const documents = {
  order: {
    editUrl: "/order/",
    essence: "order",
    component: (item) => <WorkdocOrder document={item} id={item.id} />,
  },
  timesheet: {
    editUrl: "/timesheet/",
    essence: "timesheet",
    component: (item) => <WorkdocTimesheet document={item} id={item.id} />,
  },
  request: {
    editUrl: "/request/",
    essence: "request",
    component: (item) => <WorkdocRequest document={item} id={item.id} />,
  },
  undertake: {
    editUrl: "/undertake/",
    essence: "undertake",
    component: (item) => <WorkdocUndertake document={item} id={item.id} />,
  },
  fda: {
    editUrl: "/fda/",
    essence: "fda",
    component: (item) => <WorkdocFda document={item} id={item.id} />,
  },
  repair: {
    editUrl: "/repair/",
    essence: "repair",
    component: (item) => <WorkdocRepair document={item} id={item.id} />,
  },
  waybill: {
    editUrl: "/delivery/waybill/",
    essence: "delivery",
    component: (item) => <WorkdocDelivery document={item} id={item.id} />,
  },
  cancellation: {
    editUrl: "/delivery/cancellation/",
    essence: "delivery",
    component: (item) => <WorkdocDelivery document={item} id={item.id} />,
  },
  installation: {
    editUrl: "/delivery/installation/",
    essence: "delivery",
    component: (item) => <WorkdocDelivery document={item} id={item.id} />,
  },
  troubleshooting: {
    editUrl: "/delivery/troubleshooting/",
    essence: "delivery",
    component: (item) => <WorkdocDelivery document={item} id={item.id} />,
  },
  bunker: {
    editUrl: "/bunkerorder/",
    essence: "bunker",
    component: (item) => <WorkdocBunkerOrder document={item} id={item.id} />,
  },
  act_maintenance: {
    editUrl: "/act_maintenance/",
    essence: "act",
    component: (item) => <WorkdocActMaintenance document={item} id={item.id} />,
  },
  template: {
    essence: "manual",
  },
  workdoc: {
    essence: "manual",
  },
};
const typeDocuments = [
  "order",
  "request",
  "waybill",
  "cancellation",
  "installation",
  "troubleshooting",
  "undertake",
  "fda",
  "repair",
  "bunker",
  "act_maintenance",
  "timesheet",
];

export default class WorkdocItem extends React.Component {
  static contextType = Context;
  constructor(props) {
    super(props);

    this.state = {
      sourceRole: {},
      openRolesModal: false,
      openItemInfo: false,
      redirect: false,
      pending: false,
      item: null,
      scale: 0.5,
      containerRef: React.createRef(),
      documentRef: React.createRef(),
    };
  }

  componentDidMount() {
    this.load();
  }
  componentDidUpdate(prevProps) {
    if (
      prevProps.structureId !== this.props.structureId ||
      prevProps.listMode !== this.props.listMode ||
      prevProps.itemId !== this.props.itemId
    ) {
      this.load();
    }
  }

  onMethodFinish = () => {
    this.load();
    if (this.props.onMethodFinish) {
      this.props.onMethodFinish();
    }
  };

  onResize = () => {
    if (this.state.item && !this.state.pending) {
      this.adjustScale();
    }
  };

  toggleRolesModal = (sourceRole) => {
    this.setState((state) => {
      return {
        sourceRole: sourceRole || {},
        openRolesModal: !state.openRolesModal,
        openItemInfo: !state.openRolesModal ? true : state.openItemInfo,
      };
    });
  };

  toggleOpenInfo = () => {
    this.setState((state) => {
      return { openItemInfo: !state.openItemInfo };
    });
  };

  onRemoveParent = async () => {
    this.setState(
      (state) => {
        let { item } = state;
        item.parent = 0;
        return { item };
      },
      () => {
        this.edit();
      }
    );
  };

  adjustScale = () => {
    let container = this.state.containerRef.current;
    let document = this.state.documentRef.current;

    if (container) {
      const containerWidth = container.offsetWidth;

      if (containerWidth) {
        let scale = containerWidth / 991;
        if (scale > 1) scale = 1;

        this.setState({ scale });
        if (document) {
          const documentHeight = document.offsetHeight;
          if (documentHeight) {
            let newHeight = Math.ceil(documentHeight * scale);
            container.style.height = `${newHeight}px`;
          }
        }
      }
    }
  };

  load = async () => {
    if (this.props.itemId) {
      this.setState({ pending: true, redirect: false });

      let item = {};
      let document = await this.context.api.q(`/document/get`, {
        id: this.props.itemId,
      });
      if (document.id) {
        if (documents[document.classcode]) {
          item = await this.context.api.q(
            `/${documents[document.classcode].essence}/get`,
            { id: this.props.itemId }
          );
        }
      }

      if (item) {
        item.canEdit = false;
        item.canDoAction = false;
        item.canEditRoles = false;
        item.canRespond = false;

        item.prioritycode = document.prioritycode;
        item.priorityname = document.priorityname;

        if (item.classcode === "template") {
          item.canEdit = true;
        }
        if (item.classcode === "workdoc") {
          if (item.statetypecode === "created") {
            item.canEdit = true;
            item.canEditRoles = true;
          }
          if (item.owner !== this.context.user.id) {
            item.canRespond = true;
          }
          item.canDoAction = true;
        }
        if (typeDocuments.includes(item.classcode)) {
          if (item.statetypecode === "created") {
            item.canEdit = true;
          }
          item.canEditRoles = true;
          item.canDoAction = true;
        }

        if (item.parent) {
          let parent = await this.context.api.q("/document/get", {
            id: item.parent,
          });
          if (parent) {
            item.parent = parent;
          }
        }
      }

      this.setState({ pending: false, item }, () => {
        if (item.raw) {
          let raw = this.context.api.JSONdecode(item.raw);
          if (raw) {
            this.restoreData(raw);
          }
        }
      });
    } else {
      this.setState({ pending: false, item: null });
    }
  };

  restoreData = (data = {}) => {
    if (this.state.containerRef.current) {
      const inputBlocks = this.state.containerRef.current.querySelectorAll(
        "input, select, textarea"
      );

      if (inputBlocks) {
        const arInputBlocks = Array.from(inputBlocks);
        arInputBlocks.forEach((inputBlock, index) => {
          let id = inputBlock.id || `noId${index}`;
          if (inputBlock.type === "checkbox" || inputBlock.type === "radio") {
            inputBlock.checked = data[id];
          } else {
            inputBlock.value = data[id];
          }
          /* if (this.state.item.classcode !== "template") {
            inputBlock.disabled = true;
          }*/
        });
      }
    }
  };

  edit = async () => {
    const { item } = this.state;
    if (typeDocuments.includes(item.classcode)) {
      const doc = documents[item.classcode] || {};
      if (doc.editUrl) {
        this.context.redirect(`${doc.editUrl}${item.id}/`);
      }
      return;
    }

    let idData = {};
    let codeData = {};
    this.setState({ pending: true });
    if (this.state.containerRef.current) {
      const inputBlocks = this.state.containerRef.current.querySelectorAll(
        "input, select, textarea"
      );
      if (inputBlocks) {
        const arInputBlocks = Array.from(inputBlocks);
        arInputBlocks.forEach((inputBlock, index) => {
          let id = inputBlock.id || `noId${index}`;
          let value =
            inputBlock.type === "checkbox" || inputBlock.type === "radio"
              ? inputBlock.checked
              : inputBlock.value;
          idData[id] = value;

          let code = inputBlock.dataset.code || `noCode${index}`;
          if (inputBlock.type === "checkbox" || inputBlock.type === "radio") {
            if (!codeData.hasOwnProperty(code)) {
              codeData[code] = inputBlock.type === "checkbox" ? [] : "";
            }
            if (inputBlock.checked) {
              if (inputBlock.type === "radio") {
                codeData[code] = inputBlock.dataset.value || true;
              }
              if (inputBlock.type === "checkbox") {
                codeData[code].push(inputBlock.dataset.value || true);
              }
            }
          } else {
            codeData[code] = inputBlock.value;
          }
        });
      }
    }

    const itemId = item.classcode === "template" ? null : item.id;
    const respond = this.props.respond || null;
    const parent = item.classcode === "template" ? respond : item.parent;

    let result = await this.context.api.q("/manual/set", {
      id: itemId,
      parent: parent,
      content: item.content,
      rendered: item.rendered,
      label: item.label,
      structure: item.structure,
      raw: idData,
      form: codeData,
      type: this.context.getType("public.workdoc"),
    });

    if (result !== false) {
      if (result.id) {
        if (result.id === itemId) {
          this.load();
        } else {
          if (item.classcode === "template" && respond) {
            /* await this.context.api.q("/manual/member/set", {
              role: 0,
              member: item.owner,
              id: result.id,
            });*/
          }
          this.setState({
            redirect: `/workdoc/draft/any/${result.id}/`,
          });
        }
      } else {
        this.context.toast(
          "Не удалось сохранить документ по неизвестной причине",
          "error"
        );
        this.setState({ pending: false });
      }
    } else {
      this.context.toast("Не удалось сохранить документ", "error");
      this.setState({ pending: false });
    }
  };

  render() {
    if (this.state.redirect) {
      return <Redirect to={this.state.redirect} />;
    }

    if (!this.state.item)
      return <Blocker spinnerFixed hAuto on={this.state.pending}></Blocker>;
    if (!this.state.item.id)
      return (
        <Blocker spinnerFixed hAuto on={this.state.pending}>
          <DefaultNotFound />
        </Blocker>
      );
    if (
      this.state.item.classcode === "template" &&
      this.state.item.statetypecode !== "disabled"
    ) {
      return (
        <Blocker spinnerFixed hAuto on={this.state.pending}>
          <DefaultNotFound message="Этот шаблон не утвержден. Его нельзя использовать в рабочей документации" />
        </Blocker>
      );
    }

    const { item } = this.state;
    const document = documents[item.classcode] || {};
    return (
      <>
        <Blocker spinnerFixed hAuto on={this.state.pending}>
          <div className="mb-4 pb-3 border-bottom no-print">
            <div className="mb-1">
              <div
                className="font-weight-bold  cursor-pointer"
                onClick={this.toggleOpenInfo}
              >
                <PriorityIcon {...item} className="mr-1" />
                {item.label}
                {item.classcode !== "template" && (
                  <span className="ml-2 text-muted text-hover-primary small nowrap">
                    Подробнее
                    <i
                      className={`fa ml-1 ${
                        this.state.openItemInfo
                          ? "fa-angle-up"
                          : "fa-angle-down"
                      }`}
                    ></i>
                  </span>
                )}
              </div>
            </div>
            {this.state.openItemInfo && item.classcode !== "template" && (
              <div className="my-2 w-100 line-left-primary">
                <WorkdocItemInfo
                  onRemoveParent={this.onRemoveParent}
                  item={item}
                  openRolesModal={this.state.openRolesModal}
                  toggleRolesModal={this.toggleRolesModal}
                  sourceRole={this.state.sourceRole}
                />
              </div>
            )}
            <div className="mb-1 d-flex justify-content-between align-items-center w-100">
              <div className="d-flex justify-content-end align-items-center  ">
                {item.canEdit ? (
                  <button
                    onClick={() => this.edit()}
                    className="btn btn-white  btn-icon"
                  >
                    {item.classcode === "template" && (
                      <i className="fa fa-check"></i>
                    )}
                    {item.classcode === "workdoc" && (
                      <i className="fa fa-save"></i>
                    )}
                    {typeDocuments.includes(item.classcode) && (
                      <i className="fa fa-pencil"></i>
                    )}
                  </button>
                ) : null}

                {item.canRespond ? (
                  <Link
                    to={`/workdoc/add/any/?respond=${item.id}`}
                    className="btn btn-white  btn-icon"
                    title="Ответить"
                  >
                    <i className="fa fa-mail-forward"></i>
                  </Link>
                ) : null}

                {item.canEditRoles ? (
                  <button
                    onClick={() =>
                      this.toggleRolesModal({
                        state: item.state,
                      })
                    }
                    className="btn btn-white btn-icon"
                  >
                    <i className="fa fa-address-book-o"></i>
                  </button>
                ) : null}

                {item.classcode !== "template" && (
                  <>
                    <EssenceAreaChange
                      item={item}
                      onFinish={this.onMethodFinish}
                      button={(onClick) => (
                        <div
                          title="Сменить подразделение"
                          className="btn btn-white btn-icon"
                          onClick={onClick}
                        >
                          <i className="fa fa-sitemap"></i>
                        </div>
                      )}
                    />
                    <FilesModalButton objectId={item.id}>
                      <i className="fa fa-upload"></i>
                    </FilesModalButton>

                    <CommentsButton objectId={item.id}>
                      <i className="fa fa-comment-o"></i>
                    </CommentsButton>

                    <WorkdocPrintButton objectId={item.id}>
                      <i className="fa fa-print"></i>
                    </WorkdocPrintButton>
                  </>
                )}
              </div>
              {item.canDoAction ? (
                <div className="ml-1 pl-2 border-left d-flex justify-content-end align-items-center">
                  <EssenceStateLabel
                    stateCode={item.statetypecode}
                    stateLabel={item.statelabel}
                    essence="document"
                    id={item.id}
                  />
                  <EssenceActionsDropdown
                    essence={"document"}
                    key={item.id}
                    id={item.id}
                    label={item.label}
                  />
                </div>
              ) : null}
            </div>
          </div>
          {document.component && <div>{document.component(item)}</div>}

          {item.classcode === "template" || item.classcode === "workdoc" ? (
            <ReactResizeDetector
              handleWidth
              handleHeight={false}
              onResize={this.onResize}
            >
              <div
                className="document-view-container"
                ref={this.state.containerRef}
              >
                <div
                  ref={this.state.documentRef}
                  style={{ transform: `scale(${this.state.scale})` }}
                  className="documentViewer fit"
                  dangerouslySetInnerHTML={{
                    __html: item.rendered,
                  }}
                ></div>
              </div>
            </ReactResizeDetector>
          ) : null}
        </Blocker>
      </>
    );
  }
}
